export default "__VITE_ASSET__BvGInU28__"